export const isOpen = state => state.getIn(['prompt', 'isOpen']);

export const getPromptLocation = state => state.getIn(['prompt', 'location']);
